import React from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";

import Home from "@/pages/Home";
import AdminGate from "@/pages/AdminGate";
import AdminDashboard from "@/pages/AdminDashboard";
import UserLogin from "@/pages/UserLogin";
import RequiredPassword from '@/pages/RequiredPassword';
import UserDashboard from "@/pages/UserDashboard";
import { auth } from "@/lib/api";
import ErrorBoundary from "@/components/ui/ErrorBoundary";
import SessionEntry from '@/components/SessionEntry';
import SessionHandoff from '@/pages/SessionHandoff';

import "@/App.css";

const RequireAdmin = ({ children }) => (auth.getAdmin() ? children : <Navigate to="/admin" replace />);
const RequireUser = ({ children }) => (auth.getUser() ? children : <Navigate to="/users" replace />);

function App() {
  return (
    <ErrorBoundary>
        <BrowserRouter>
          <Toaster
            position="top-center"
            richColors
            toastOptions={{
              style: { fontFamily: "IBM Plex Sans Arabic, sans-serif", direction: "rtl" },
            }}
          />
          <SessionEntry><Routes>
            <Route path="/auth/continue" element={<SessionHandoff />} />
            <Route path="/" element={<Home />} />
            <Route path="/admin" element={<AdminGate />} />
            <Route
              path="/admin/dashboard/*"
              element={
                <RequireAdmin>
                  <AdminDashboard />
                </RequireAdmin>
              }
            />
            <Route path="/user/password-required" element={<RequireUser><RequiredPassword /></RequireUser>} />
            <Route path="/admin/view-user/:userId" element={<RequireAdmin><UserDashboard viewMode /></RequireAdmin>} />
            <Route path="/users" element={<UserLogin />} />
            <Route
              path="/user/dashboard"
              element={
                <RequireUser>
                  <UserDashboard />
                </RequireUser>
              }
            />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes></SessionEntry>
        </BrowserRouter>
    </ErrorBoundary>
  );
}

export default App;
